module.exports = __webpack_public_path__ + "static/media/imgn_mexicoycereales.18efe164.png";